// @flow
import type {
  ResponseProducts,
  StateProducts,
  Variants,
} from '../../sharedTypes';

type FlattenedProducts = {|
  products: StateProducts,
  variants: Variants,
|};

export function flattenProducts(products: ResponseProducts): FlattenedProducts {
  const flattenedProducts: StateProducts = {};
  const extractedVariants: Variants = {};
  for (const productId in products) {
    const product = products[productId];
    const { variants, ...rest } = product;
    // Unfortunately, flow doesn't handle copying objects with spread
    // when the second spread object has an indexer. Hopefully they'll
    // fix this soon. See https://medium.com/flow-type/spreads-common-errors-fixes-9701012e9d58
    for (const variantId in variants) {
      extractedVariants[variantId] = variants[variantId];
    }
    flattenedProducts[productId] = rest;
  }

  return {
    products: flattenedProducts,
    variants: extractedVariants,
  };
}

const getVariantFromDescriptors = (product) => {
  const { variantDescriptors, legacyPostId, displayOrder } = product;
  if (variantDescriptors.length === 0) {
    return null;
  }
  return {
    descriptor: variantDescriptors.map((d) => d.descriptor).join(),
    descriptors: variantDescriptors,
    legacyPostId,
    displayOrder,
  };
};

export function flattenProductArray(products) {
  const extractedVariants = {};
  products.map((product) => {
    const variant = getVariantFromDescriptors(product);
    if (extractedVariants[product.productId]) {
      extractedVariants[product.productId].push(variant);
    } else {
      extractedVariants[product.productId] = [variant];
    }
  });
  return extractedVariants;
}

// export function getVariantQuantities(responseProducts) {
//   try {
//     return responseProducts.reduce((variantQuantities, product) => {
//       const productVariantQuantities = product.variants.reduce(
//         (_productVariantQuantities, variant) => {
//           return {
//             ..._productVariantQuantities,
//             [variant.id]: variant.quantity
//           };
//         },
//         {}
//       );
//       return {
//         ...variantQuantities,
//         ...productVariantQuantities
//       };
//     }, {});
//   } catch {
//     return {};
//   }
// }
